



















































import Vue from "vue";

export default Vue.extend({
  name: "Properties",
  props: {
    title: { type: String, default: "" },
    productTitle: { type: String, default: "" },
    description: { type: String, default: "" },
    retailer: { type: Object, default: () => ({}) },
    properties: { type: Array, default: () => [] },
    sticky: { type: Boolean, default: false },
    isOnSale: { type: Boolean, default: false },
    isOnDiscount: { type: Boolean, default: false },
    isTop: { type: Boolean, default: false },
  },
  data: () => ({
    scrolled: false,
  }),
});
